import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import { trigger, style, transition, animate } from "@angular/animations";
import { DsNotificationService } from "../../services/ds-notification.service";

@Component({
  selector: "ds-notification",
  templateUrl: "./ds-notification.component.html",
  styleUrls: ["./ds-notification.component.scss"],
  animations: [
    trigger("fadeIn", [
      transition("void => visible", [
        style({
          opacity: 0,
        }),
        animate(
          "150ms ease-out",
          style({
            opacity: 1,
          })
        ),
      ]),
      transition("visible => hidden", [
        animate(
          "170ms ease-in",
          style({
            opacity: 0,
          })
        ),
      ]),
    ]),
  ],
})
export class DsNotificationComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() type = "neutral";
  @Input() title!: string;
  @Input() message!: string;
  @Input() actionLabel?: string = "";
  @Input() callAction?: () => void;
  @Input() animationState = "visible";
  @Input() topPosition = "16px";
  /** When set, overrides the default close visibility (!actionLabel). */
  @Input() showClose?: boolean;

  @ViewChild("notificationElement", { static: false }) notificationElement!: ElementRef;

  icon: string;

  get shouldShowClose(): boolean {
    return this.showClose ?? !this.actionLabel;
  }

  constructor(private dsNotificationService: DsNotificationService, private elementRef: ElementRef) {}

  ngOnInit() {
    this.checkIcon();
  }

  ngAfterViewInit() {
    this.focusNotification();
  }

  close() {
    this.dsNotificationService.close();
  }

  onAction() {
    if (this.callAction) {
      this.callAction();
    }
    this.close();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["type"]) {
      this.checkIcon();
    }
  }

  checkIcon() {
    switch (this.type) {
      case "neutral":
        this.icon = "info-line";
        break;
      case "warning":
        this.icon = "warning-line";
        break;
      case "success":
        this.icon = "check-line";
        break;
      case "danger":
        this.icon = "exclamation-line";
        break;
      default:
        this.icon = "info-line";
        break;
    }
  }

  private focusNotification() {
    const isMobile = window.innerWidth <= 767;

    if (isMobile) {
      setTimeout(() => {
        if (this.notificationElement && this.notificationElement.nativeElement) {
          this.notificationElement.nativeElement.focus();
        } else {
          this.elementRef.nativeElement.focus();
        }
      }, 100);
    }
  }
}
